<template lang="pug">
  .process-indicator
    .d-flex.flex-row.justify-content-center
      ol.progress-tracker.p-0
        li(v-for="(item, index) in _value" :class="{ current: item.current }") {{ index + 1 }}. {{ item.text }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 進捗インジケータ
 */
@Component
export default class ProcessIndicator extends Vue {
  /** インジケータ表示内容 */
  @Prop({ required: true })
  value!: Array<ProcessIndicatorModel>;

  get _value(): Array<ProcessIndicatorModel> {
    return this.value;
  }
}

export interface ProcessIndicatorModel {
  text: string;
  current: boolean;
}
</script>

<style lang="scss" scopeed>
@import "../../styles/mobile/_colors.scss";

// プログレストラッカー
ol.progress-tracker {
  list-style: none;
  li {
    height: 2.7rem;
    padding: 0.5rem 1rem 0.5rem 1.8rem;
    color: $font-indicator;
    background: $bg-indicator;
    display: inline-block;

    border: 1px solid $border-btn;

    &::before {
      float: right;
      display: block;
      margin-top: -0.5rem;
      margin-left: auto;
      margin-right: -1.5rem;
      height: 1.25rem;
      width: 1.25rem;
      content: " ";
      transform: skew(30deg);
      background: $bg-indicator;
      border-right: 1px solid $border-btn;
    }
    &::after {
      position: relative;
      display: block;
      margin-top: -0.75rem;
      margin-left: auto;
      margin-right: -1.5rem;
      height: 1.25rem;
      width: 1.25rem;
      content: " ";
      transform: skew(-30deg);
      background: $bg-indicator;
      border-right: 1px solid $border-btn;
    }
    &:first-child {
      padding-left: 1rem;
      border-radius: 5px 0 0 5px;
    }
    &:last-child {
      padding-left: 2rem;
      padding-right: 1rem;
      border-radius: 0 5px 5px 0;
    }
    &:last-child::before {
      border: 0;
      background: transparent !important;
    }
    &:last-child::after {
      border: 0;
      background: transparent !important;
    }
    // 現在表示している進捗用
    &.current {
      background: $bg-indicator-current;
      color: $font-indicator-current;
      &::before {
        background: $bg-indicator-current;
      }
      &::after {
        background: $bg-indicator-current;
      }
      &:last-child::before {
        border: 0;
        background: transparent !important;
      }
      &:last-child::after {
        border: 0;
        background: transparent !important;
      }
    }
  }
}
</style>
